export const generateQuillOpsFromText = (currentOps: $TSFixMe, text: string) => {
    const lines = (text.endsWith('\n') ? text.substring(0, text.length - 1) : text).split('\n');
    const textOps = currentOps[0];
    const newlineOps = currentOps[1];
    const newOps: $TSFixMe = [];

    lines.forEach(line => {
        newOps.push({ ...textOps, insert: line });
        newOps.push({ ...newlineOps });
    });

    return newOps;
};
